import { useContext } from 'react'

import { MODAL_ANIMATION_DURATION, ModalContext, ModalProvider } from './Provider'

export { ModalProvider, ModalContext, MODAL_ANIMATION_DURATION }
export type { IModalComponentProps, IModalContextProps } from './Provider'

export const useModal = () => useContext(ModalContext)
